// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2r-1";
export var rateTableServiceLevelDropdown = "_2r-3";
export var rateTableTypeDropdown = "_2r-0";
export var rateTableValueModeDropdown = "_2r-2";